<div class="modal-header" *ngIf="showAsDialog">
    <h4 class="modal-title">Part Search - {{ mode }}</h4>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="{{ !showSideBar ? ' d-contents' : ' flex-fill d-flex' }}">
        <div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '600px' : '100%' }" *ngIf="parts">
            <dx-data-grid
                #partsGrid
                [dataSource]="parts"
                keyExpr="id"
                [columnAutoWidth]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onRowPrepared)="rowPrepare($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onContentReady)="onContentReady($event)"
                (onExporting)="onExporting($event)"
                (onInitialized)="onGridInitialized($event)"
            >
                <dxi-column dataField="id" [allowEditing]="false" [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"></dxi-column>
                <dxi-column
                    dataField="inStock"
                    caption="InStock"
                    width="70"
                    [allowEditing]="false"
                    [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    dataField="allocated"
                    caption="Allocated"
                    width="70"
                    [allowEditing]="false"
                    [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    dataField="projectedInventory"
                    caption="Prj.Inv."
                    width="70"
                    [allowEditing]="false"
                    [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>

                <dxi-column
                    dataField="_onOrder"
                    caption="PartsOnOrder"
                    width="70"
                    [allowEditing]="false"
                    [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"
                    cellTemplate="poTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="_onBackOrder"
                    caption="BackOrder"
                    width="70"
                    [allowEditing]="false"
                    [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"
                    cellTemplate="poTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="onOrderParent"
                    width="70"
                    caption="OnOrder[Parent]"
                    [allowEditing]="false"
                    [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    dataField="lastAdjustment"
                    width="70"
                    caption="Adj. Note"
                    [allowEditing]="false"
                    [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>

                <dxi-column dataField="category" width="150" [visible]="!columnLimitMode && !partDetailMode" [allowEditing]="!readOnly"></dxi-column>
                <dxi-column dataField="partNumber" width="350" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="aliasHTML" caption="Aliases" width="350" [allowEditing]="false" [encodeHtml]="false"></dxi-column>
                <dxi-column dataField="description" width="350" [allowEditing]="!readOnly"></dxi-column>
                <dxi-column dataField="partTypes" caption="Part Type(s)" width="100" [allowEditing]="false" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column dataField="isAssembly" caption="IsAssembly" width="100" [allowEditing]="false" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column dataField="isChild" caption="IsChild" width="100" [allowEditing]="false" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column dataField="hasChildren" caption="HasChildren" width="100" [allowEditing]="false" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column dataField="hasAliases" caption="HasAliases" width="100" [allowEditing]="false" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column dataField="hasServiceCost" caption="HasServiceCost" width="115" [allowEditing]="false" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column dataField="serviceCost" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column dataField="mfgPartNumber" width="100" [allowEditing]="false" [visible]="!showMfgInfoMode"></dxi-column>
                <dxi-column dataField="mfgDescription" width="100" [allowEditing]="!readOnly" [visible]="!columnLimitMode && !partDetailMode"></dxi-column>
                <dxi-column
                    *ngIf="canSeeCost"
                    dataField="cost"
                    [editorOptions]="{ step: 0 }"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="!readOnly"
                ></dxi-column>
                <dxi-column *ngIf="canSeeCost" dataField="calculatedCost" width="100" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="tierPricingOverride"
                    width="100"
                    [allowEditing]="!readOnly"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <!-- <dxi-column
                    *ngIf="canSeePricing"
                    dataField="price"
                    caption="Dealer Price"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column> -->
                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="retailPrice"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>

                <dxi-column
                    dataField="tier1"
                    caption="Tier Price (Base)"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>

                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="tier2"
                    caption="Tier Price (2) Dealer"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="tier3"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="tier4"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    *ngIf="canSeePricing"
                    dataField="tier5"
                    width="100"
                    [format]="{ type: 'currency', precision: 2 }"
                    [allowEditing]="false"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>

                <dxi-column dataField="axleCount" width="150" [visible]="!columnLimitMode && !partDetailMode" [allowEditing]="!readOnly"></dxi-column>
                <dxi-column dataField="freightMultiplier" width="150" [visible]="!columnLimitMode && !partDetailMode" [allowEditing]="!readOnly"></dxi-column>
                <dxi-column dataField="preferredVendor" width="200" [allowEditing]="!readOnly" [visible]="!columnLimitMode"></dxi-column>
                <dxi-column
                    dataField="reOrderMinimum"
                    [editorOptions]="{ step: 0 }"
                    [allowEditing]="!readOnly"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    dataField="reOrderQuantity"
                    [editorOptions]="{ step: 0 }"
                    [allowEditing]="!readOnly"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column
                    dataField="unitOfMeasure"
                    [allowEditing]="!readOnly"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column dataField="trackInventory" [allowEditing]="!readOnly" [visible]="!columnLimitMode && !partDetailMode && !purchaseOrderMode"></dxi-column>
                <dxi-column dataField="fontColor" [allowEditing]="!readOnly" [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"></dxi-column>
                <dxi-column dataField="vendorId" [allowEditing]="false" [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"></dxi-column>
                <dxi-column
                    dataField="lastProcessed"
                    width="150"
                    [allowEditing]="false"
                    [format]="{ type: 'shortDate' }"
                    [visible]="!showAsDialog && !columnLimitMode && !partDetailMode && !purchaseOrderMode"
                ></dxi-column>
                <dxi-column dataField="hasAttachments" width="150" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="costMismatch" width="150" [allowEditing]="false"></dxi-column>
                <dxi-column dataField="attachmentList" caption="Attachments" width="350" [allowEditing]="false" cellTemplate="attachmentTemplate"></dxi-column>

                <dxo-scrolling mode="virtual" [preloadEnabled]="true" [renderAsync]="false"></dxo-scrolling>
                <dxo-selection [mode]="selectMode"></dxo-selection>
                <dxo-search-panel *ngIf="!showAsDialog" class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-editing [mode]="'batch'" [allowUpdating]="!showAsDialog && !readOnly"></dxo-editing>
                <dxo-state-storing [enabled]="!showAsDialog || storageKey !== 'part-search-grid'" type="localStorage" [storageKey]="storageKey"></dxo-state-storing>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="'/parts/' + cell.data.id">{{ cell.value || '(blank)' }}</a>
                </div>
                <div *dxTemplate="let cell of 'poTemplate'">
                    <a [routerLink]="[]" (click)="purchaseOrderDialog(cell.data.id)">{{ cell.value || '' }}</a>
                </div>
                <div *dxTemplate="let cell of 'attachmentTemplate'">
                    <div class="d-flex flex-column">
                        @for (attachment of cell.data.attachmentsList; track attachment.id) {
                            <a [routerLink]="[]" (click)="openAttachment(attachment)"> {{ attachment.name || '' }} </a>
                        }
                    </div>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <ng-container *ngIf="!showAsDialog">
                        <button
                            class="btn btn-success"
                            (click)="open(partsGrid.instance.getSelectedRowsData()[0].id)"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                        >
                            Open
                        </button>
                        <button class="btn btn-secondary ms-2" (click)="open()" [hidden]="readOnly">New</button>
                        <button
                            class="btn btn-danger ms-2"
                            (click)="delete(partsGrid.instance.getSelectedRowsData())"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length === 0"
                            [hidden]="!auth.hasRole('Administrator') || readOnly"
                        >
                            Delete
                        </button>
                        <button class="btn btn-primary ms-4" (click)="duplicate()" [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1" [hidden]="readOnly">
                            Duplicate
                        </button>
                        <button
                            class="btn btn-primary ms-4"
                            (click)="lookup(partsGrid.instance.getSelectedRowsData()[0].id)"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly"
                        >
                            Lookup
                        </button>

                        <button class="btn btn-primary ms-2" (click)="partTypeBulkEdit()" [disabled]="partsGrid.instance.getSelectedRowsData().length === 0" [hidden]="readOnly">
                            Part Type(s)
                        </button>
                        <button class="btn btn-primary ms-2" (click)="partOptionBulkEdit()" [disabled]="partsGrid.instance.getSelectedRowsData().length === 0" [hidden]="readOnly">
                            Options
                        </button>
                        <button
                            class="btn btn-warning ms-4"
                            (click)="bulkEdit(partsGrid.instance.getSelectedRowsData())"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length === 0"
                            [hidden]="readOnly"
                        >
                            Bulk Edit
                        </button>
                        <button
                            class="btn btn-secondary ms-4"
                            (click)="addPartPurchase(partsGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="partsGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly"
                        >
                            Inventory Adjustment
                        </button>
                        <button class="btn btn-sm btn-success ms-2" (click)="refreshCalcCosts()" [hidden]="readOnly">Refresh Calculated Costs</button>
                        <button class="btn btn-sm btn-success ms-4" (click)="save()" *ngIf="hasChanges() && !readOnly" [hidden]="readOnly">Save</button>
                        <button class="btn btn-sm btn-danger ms-2" (click)="cancelEdits()" *ngIf="hasChanges() && !readOnly" [hidden]="readOnly">Cancel</button>
                    </ng-container>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="parts" class="me-3"
                        ><strong
                            >{{ partsGrid.instance.totalCount() + ' items' }}
                            {{ partsGrid.instance.getSelectedRowsData().length > 0 ? partsGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong></span
                    >
                </div>
            </dx-data-grid>
        </div>

        <div *ngIf="!!showSideBar && !!selectedParts && selectedParts.length > 0" class="flex-fill" style="max-width: 450px" [hidden]="selectedParts.length === 0">
            <div class="ps-4 pe-4">
                <h4>Selected Parts</h4>
                <table [hidden]="!selectedParts || selectedParts.length === 0" class="table table-hover">
                    <thead>
                        <tr>
                            <th>Part #</th>
                            <th>Description</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [hidden]="selectedParts.length > 0">
                            <td colspan="9">No items</td>
                        </tr>
                        <tr [hidden]="selectedParts.length === 0" *ngFor="let info of selectedParts">
                            <td class="col-xs-2">{{ info.partNumber }}</td>
                            <td class="col-xs-2">{{ info.description }}</td>
                            <td class="col-xs-2"><i class="fa fa-close" (click)="removeFromSelected(info)"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [visible]="isToastVisible"> </dx-toast>
    </div>
    <dx-popup
        title="Refreshing Calculated Costs"
        [visible]="costProgressVisible"
        [width]="480"
        [height]="220"
        [showCloseButton]="false"
        [dragEnabled]="false"
        [hideOnOutsideClick]="false"
    >
        <div *dxTemplate="let data of 'content'" class="d-flex flex-column gap-3 p-2">
            <div class="text-center">
                {{ costProgressPercent >= 100 ? 'Saving changes to database...' : 'Processing ' + costProgressCurrent + ' of ' + costProgressTotal + ' save batches' }}
            </div>
            <div class="progress" style="height: 22px">
                <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    [class.bg-success]="costProgressPercent < 100"
                    [class.bg-warning]="costProgressPercent >= 100"
                    role="progressbar"
                    [style.width]="costProgressPercent > 0 ? '100%' : '0%'"
                    [attr.aria-valuenow]="costProgressCurrent"
                    aria-valuemin="0"
                    [attr.aria-valuemax]="costProgressTotal"
                >
                    {{ costProgressPercent }}%
                </div>
            </div>
            <div class="text-muted text-center small">
                {{ costProgressPercent >= 100 ? 'Please wait, this may take a moment...' : costProgressPartNumber || 'Initializing...' }}
            </div>
        </div>
    </dx-popup>
    <div class="modal-footer" *ngIf="showAsDialog">
        <button type="button" (click)="select(false)" class="btn btn-success ms-3">Select</button>
        <button type="button" (click)="closeDialog()" class="btn btn-secondary ms-1">Save & Close</button>
        <button type="button" (click)="cancel()" class="btn btn-danger ms-1">Cancel</button>
    </div>
</div>
